import './InfoBanner.scss';

import React from 'react';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleOutlinedIcon from '@mui/icons-material/CheckCircleOutlined';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

type Variant = 'info' | 'warning' | 'success' | 'error';

type Props = {
  children: React.ReactNode;
  className?: string;
  variant?: Variant;
  'data-testid'?: string;
};

const VARIANT_ICONS = {
  info: InfoOutlinedIcon,
  warning: WarningAmberIcon,
  success: CheckCircleOutlinedIcon,
  error: ErrorOutlineIcon,
};

// forwardRef so the banner can be used as a child of MUI Tooltip (which needs
// to attach a ref to its child).
const InfoBanner = React.forwardRef<HTMLDivElement, Props>(
  ({ children, className, variant = 'info', ...rest }, ref) => {
    const Icon = VARIANT_ICONS[variant] ?? InfoOutlinedIcon;
    return (
      <div
        ref={ref}
        className={`info-banner info-banner--${variant}${className ? ` ${className}` : ''}`}
        role='note'
        {...rest}
      >
        <Icon className='info-banner__icon' />
        <span>{children}</span>
      </div>
    );
  }
);

InfoBanner.displayName = 'InfoBanner';

export default InfoBanner;
